import React, { useCallback, useContext, useEffect, useState } from 'react';
import { dataGridModel, queryClient as qc } from 'keys';
import { Table } from 'components';
import { abilityGroups } from 'keys'
import { groupBy } from 'lodash';
import { Space } from 'styles/GlobalStyle';

const AssessmentTable = (props) => {
    const { data, nestedTable, nestedColumns } = props

    const grouped = groupBy(data, 'ability_group');
    const foundationalData = grouped[abilityGroups.FOUNDATIONAL_SKILLS.key] || [];
    const fluencyData = grouped[abilityGroups.FLUENCY.key] || [];

    return (
        <>
            <div className="ability-groups">
                {foundationalData.length > 0 &&
                    <div className="ability-group">
                        <div className="ability-group-header">
                            {abilityGroups.FOUNDATIONAL_SKILLS.icon}
                            {abilityGroups.FOUNDATIONAL_SKILLS.label}
                        </div>
                        <Table
                            bgHead
                            hideSorting
                            hidePagination
                            hideToolbar
                            collapseView
                            show={nestedTable}
                            columns={nestedColumns}
                            showToolbar={true}
                            data={{ results: foundationalData || [] }}
                            visibilityModelKey={dataGridModel.assessment_battery}
                        />
                    </div>
                }
                {fluencyData.length > 0 &&
                    <div className="ability-group">
                        <div className="ability-group-header">
                            {abilityGroups.FLUENCY.icon}
                            {abilityGroups.FLUENCY.label}
                        </div>
                        <Table
                            bgHead
                            hideSorting
                            hidePagination
                            hideToolbar
                            collapseView
                            show={nestedTable}
                            columns={nestedColumns}
                            showToolbar={true}
                            data={{ results: fluencyData || [] }}
                            visibilityModelKey={dataGridModel.assessment_battery}
                        />
                    </div>
                }
            </div>
        </>
    );
}

export default AssessmentTable
